export default {
    user: {
        // Loads the current user's information
        login: {
            type: "get",
            error: {
                default: "Unable to load your account information.",
            },
        },

        // Gets the user's roles
        getRoles: {
            type: "get",
            error: {
                default: "Unable to load your account information.",
            },
        },

        // Binds provided patient account as current account
        bind: {
            type: "post",
            error: {
                redirect: "/",
                default: "Unable to log you in.",
            },
        },
        /*Params:
         * - "patientID: The patient account to bind
         */

        // Gets the current account's information
        whoAmI: {
            type: "get",
            error: {
                redirect: "/",
                default: "Unable to load account information.",
            },
        },

        // Logs out the current user
        logout: {
            type: "delete",
            error: {
                redirect: "/",
            },
        },
        // extend session
        extendSession: {
            type: "delete",
            error: {
                redirect: "/",
                default: "Unable to extend session.",
            },
        },
        // Checks if provider exists
        checkProvider: {
            type: "get",
            error: {
                redirect: "/",
                400: "Something went wrong.",
                403: "You have already registered.",
            },
        },

        // Invites patient to register
        invitePatient: {
            type: "put",
            success: {
                default: "Successfully invited patient.",
            },
            error: {
                default: "Unable invite patient.",
            },
        },
        /*Params:
         * <"">data: FirstName, LastName, Email, Message for invite
         */

        // Binds the provided invitation for registration
        bindPatientInvite: {
            type: "post",
            error: {
                redirect: "/",
                400: "Invalid invite code.",
                410: "Invite not found, or has already been used.",
                default: "Failed to link invitation.",
            },
        },
        /*Params:
         * "invite: Encoded invite code
         */

        // Patient only, creates account with provided information
        registerPatient: {
            type: "post",
            error: {
                403: "You have already registered.",
                default: "Failed to register.",
            },
        },
        /*Params:
         * - <"">data: The patient information to create an account with
         * - "invite: The invite code to bind the account to
         */

        // Invites provider to register
        inviteProvider: {
            type: "put",
            success: {
                default: "Successfully invited provider.",
            },
            error: {
                default: "Unable invite provider.",
            },
        },
        /*Params:
         * <"">data: FirstName, LastName, Email, Message for invite
         */

        // Binds the provided invitation for registration
        bindProviderInvite: {
            type: "post",
            error: {
                redirect: "/",
                400: "Invalid invite code.",
                404: "Invite not found, or has already been used.",
                default: "Failed to link invitation.",
            },
        },
        /*Params:
         * "invite: Encoded invite code
         */

        // Registers a new provider account
        registerProvider: {
            type: "post",
            error: {
                default: "Failed to register.",
            },
        },
        /*Params:
         * - "data: JSON of the new provider's information
         */
    },
    verify: {
        // Generates and sends a verification code
        sendCode: {
            type: "post",
            error: {
                default: "Unable to send verification code.",
            },
        },
        /*Params:
         * - #role: account role (provider is 1, patient is 2)
         * - #loginType: verification type (email is 1, phone is 2)
         * - "loginValue: verification value (email address/phone number)
         */

        // Verifies the code that was sent
        checkCode: {
            type: "get",
            error: {
                404: "No verification attempt found. Please send a new code and try again.",
                default: "Invalid code, please try again.",
            },
        },
        /*Params:
         * - "code: The 6 digit verification code
         */
    },
    form: {
        // Sends feedback
        feedback: {
            type: "post",
            error: {
                default: "Unable to send feedback.",
            },
        },
        /*Params:
         * - <"+>data: The feedback to send
         */
    },
};
